import { usePlaylist } from 'presentation/hooks/playlist';
import React from 'react';

import './styles.scss';

interface IProps {
    children: React.ReactNode;
    isLocked: boolean;
}

export const ToroLearnSideBar = ({ children, isLocked }: IProps) => {
    const { sideBarActive, setSideBarActive } = usePlaylist();

    return (
        <div className="wrapper-sidebar">
            <div className={`sidebar ${sideBarActive && 'is-active'} ${isLocked ? 'has-footer' : 'has-not-footer'}`}>
                {children}
            </div>
            <div className={sideBarActive ? 'sidebar-blur' : 'd-none'} onClick={() => setSideBarActive(false)}></div>
        </div>
    );
};
